'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var DROPDOWN_SHOW_SELECTOR = '.dropdown.show';
var NAV_LINK_SELECTOR = '.nav-link';
var DROPDOWN_MENU_SELECTOR = '.dropdown-menu';
var MAIN_MENU_SELECTOR = '.main-menu';
var NAVBAR_HEADER_USER_SELECTOR = '.navbar-header .user';
var NAVBAR_HEADER_USER_POPOVER_SELECTOR = '.navbar-header .user .popover';
var ARIA_EXPANDED = 'aria-expanded';
var TOP_NAV_ARIA_SELECTOR = 'div.menu-group > ul.nav.navbar-nav > li.nav-item > a';
var ARIA_HIDDEN = 'aria-hidden';
var MENU_TOGGLEABLE_LEFT_SELECTOR = '.menu-toggleable-left';
var CATEGORY_DESC_SELECTOR = '.category-desc';
var TOP_CATEGORY_SELECTOR = '.top-category';
var NAVBAR_NAV_SELECTOR = '.navbar-nav';
var FIXED_CLASS = 'fixed';
var NAVBAR_TOGGLER_SELECTOR = '.navbar-toggler';

var clearSelection = function (element) {
    $(element).closest('.dropdown').find(CATEGORY_DESC_SELECTOR).children(TOP_CATEGORY_SELECTOR)
        .detach();
    $(element).closest(DROPDOWN_SHOW_SELECTOR).children(NAV_LINK_SELECTOR).attr(ARIA_EXPANDED, 'false');
    $(element).closest(DROPDOWN_SHOW_SELECTOR).children(DROPDOWN_MENU_SELECTOR).attr(ARIA_HIDDEN, 'true');
    $(element).closest(DROPDOWN_SHOW_SELECTOR).removeClass('show');
    $(TOP_NAV_ARIA_SELECTOR).attr(ARIA_HIDDEN, 'false');
    $(element).closest('li').detach();
};

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents(MENU_TOGGLEABLE_LEFT_SELECTOR).css('position') !== FIXED_CLASS;
    };


    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
    });

    keyboardAccessibility(MAIN_MENU_SELECTOR + ' .nav-link, ' + MAIN_MENU_SELECTOR + ' .dropdown-link', // NOSONAR
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children(DROPDOWN_MENU_SELECTOR)
                        .removeClass('show');
                    menuItem.addClass('show').children(DROPDOWN_MENU_SELECTOR).addClass('show');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children(DROPDOWN_MENU_SELECTOR).removeClass('show');
                    if (menuItem.next().length <= 0) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                        .first()
                        .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children(DROPDOWN_MENU_SELECTOR).removeClass('show');
                    $(this).attr(ARIA_EXPANDED, 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children(DROPDOWN_MENU_SELECTOR).addClass('show');
                    $(this).attr(ARIA_EXPANDED, 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children(DROPDOWN_MENU_SELECTOR).removeClass('show');
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children(NAV_LINK_SELECTOR)
                        .attr(ARIA_EXPANDED, 'false');
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children(DROPDOWN_MENU_SELECTOR).removeClass('show');
                    $(this).attr(ARIA_EXPANDED, 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr(ARIA_EXPANDED, 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children(NAV_LINK_SELECTOR)
                    .attr(ARIA_EXPANDED, 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('click', function (e) {
            e.preventDefault();
            const $parent = $(this).parent(),
                $this = $(this);
            if (!isDesktop(this)) {
                // copy parent element into current UL
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                $parent.children(DROPDOWN_MENU_SELECTOR)
                    .prepend(closeMenu)
                    .attr(ARIA_HIDDEN, 'false');
                // copy navigation menu into view
                $parent.addClass('show');
                $(this).siblings(DROPDOWN_MENU_SELECTOR).addClass('show');
                $(this).attr(ARIA_EXPANDED, 'true');
                $(TOP_NAV_ARIA_SELECTOR).attr(ARIA_HIDDEN, 'true');
            } else {
                // desktop - close level-2 layout on second click
                if($parent.hasClass('show')) {
                    $parent.removeClass('show');
                    $this.siblings(DROPDOWN_MENU_SELECTOR).removeClass('show');
                    $this.attr(ARIA_EXPANDED, 'false');
                    return;
                } else {
                    // close other category flyouts before opening the current one
                    const eventElement = this;
                    $(NAVBAR_NAV_SELECTOR + ' > li').each(function () {
                        if (!$.contains(this, eventElement)) {
                            if ($(this).hasClass('show')) {
                                $(this).removeClass('show');
                                $(this).children('ul' + DROPDOWN_MENU_SELECTOR).removeClass('show');
                                $(this).children(NAV_LINK_SELECTOR).attr(ARIA_EXPANDED, 'false');
                            }
                        }
                    });
                    // need to close all the dropdowns that are not direct parent of current dropdown
                    $parent.addClass('show');
                    $this.siblings(DROPDOWN_MENU_SELECTOR).addClass('show');
                    $this.attr(ARIA_EXPANDED, 'true');
                }
            }
            // Add browse all link in level-2 section
            if(!$parent.find(TOP_CATEGORY_SELECTOR).length) {
                const linkText = $(this).data('browse-all');
                const menuitemDesc = $(this).siblings(DROPDOWN_MENU_SELECTOR).find(CATEGORY_DESC_SELECTOR).data('menuitemDescription');
                const link = $(`<a href="${$(this).attr('href')}" class="dropdown-item top-category w-auto p-1 mt-2 text16-l22"`
                    + ` data-element-linkname="Top Nav | ${menuitemDesc} | ${linkText}">${linkText}</a>`);
                const icon = $(`<i class="fa-light fa-chevron-right pl-2"></i>`);
                link.append(icon);
                $parent.find(CATEGORY_DESC_SELECTOR).append(link);
                $(link).focus();
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $(MENU_TOGGLEABLE_LEFT_SELECTOR).removeClass('in');
        $(NAVBAR_TOGGLER_SELECTOR).focus();

        $(MAIN_MENU_SELECTOR).attr(ARIA_HIDDEN, 'true');
        $(MAIN_MENU_SELECTOR).siblings().attr(ARIA_HIDDEN, 'false');
        $('header').siblings().attr(ARIA_HIDDEN, 'false');
        $('body').removeClass(FIXED_CLASS);
    });

    $(NAVBAR_NAV_SELECTOR).on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $(NAVBAR_NAV_SELECTOR).on('click', '.close-button', function (e) {
        e.preventDefault();
        $(NAVBAR_NAV_SELECTOR).find(TOP_CATEGORY_SELECTOR).detach();
        $(NAVBAR_NAV_SELECTOR).find('.nav-menu').detach();
        $(NAVBAR_NAV_SELECTOR).find('.show').removeClass('show');
        $(MENU_TOGGLEABLE_LEFT_SELECTOR).removeClass('in');

        $(MAIN_MENU_SELECTOR).siblings().attr(ARIA_HIDDEN, 'false');
        $('header').siblings().attr(ARIA_HIDDEN, 'false');
        $('body').removeClass(FIXED_CLASS);
    });

    $(NAVBAR_TOGGLER_SELECTOR).click(function (e) {
        e.preventDefault();
        $(MAIN_MENU_SELECTOR).toggleClass('in');
        $(MAIN_MENU_SELECTOR).removeClass('d-none');
        $(MAIN_MENU_SELECTOR).attr(ARIA_HIDDEN, 'false');
        $(MAIN_MENU_SELECTOR).siblings().attr(ARIA_HIDDEN, 'true');
        $('header').siblings().attr(ARIA_HIDDEN, 'true');
        $(MAIN_MENU_SELECTOR + ' .nav.navbar-nav ' + NAV_LINK_SELECTOR).first().focus(); // NOSONAR
        $('body').addClass(FIXED_CLASS);
    });

    keyboardAccessibility(NAVBAR_HEADER_USER_SELECTOR,
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $(NAVBAR_HEADER_USER_POPOVER_SELECTOR).removeClass('show');
                $('.user').attr(ARIA_EXPANDED, 'false');
            },
            9: function () { // tab
                $(NAVBAR_HEADER_USER_POPOVER_SELECTOR).removeClass('show');
                $('.user').attr(ARIA_EXPANDED, 'false');
            }
        },
        function () {
            return $('.user .popover li.nav-item');
        }
    );

    $(NAVBAR_HEADER_USER_SELECTOR).on('mouseenter focusin', function () {
        if ($(NAVBAR_HEADER_USER_POPOVER_SELECTOR).length > 0) {
            $(NAVBAR_HEADER_USER_POPOVER_SELECTOR).addClass('show');
            $('.user').attr(ARIA_EXPANDED, 'true');
        }
    });

    $(NAVBAR_HEADER_USER_SELECTOR).on('mouseleave', function () {
        $(NAVBAR_HEADER_USER_POPOVER_SELECTOR).removeClass('show');
        $('.user').attr(ARIA_EXPANDED, 'false');
    });

    $(NAVBAR_HEADER_USER_SELECTOR + ' .close-button').on('click', function () {
        $(NAVBAR_HEADER_USER_POPOVER_SELECTOR).removeClass('show');
        $('.user').attr(ARIA_EXPANDED, 'false');
    });

    $('body').on('click', '#myaccount', function () {
        event.preventDefault();
    });

    // Handle Enter Key
    $(document).on("keypress", ".triggerClickonEnter", function(event) {
        if(event.keyCode === 13) {
          $(this).trigger("click");
        }
    });

    // Close the Menu after clicking outside
    $(document).on('click', function(event) {
        var openMenu = '';
        if ($(window).width() > 768) {
            openMenu = $('#sg-navbar-collapse .nav-item.show');
            if (openMenu && !$(event.target).closest('#sg-navbar-collapse').length) {
                $(openMenu).removeClass('show');
                $(openMenu).find(DROPDOWN_MENU_SELECTOR).removeClass('show');
                $(openMenu).find(NAV_LINK_SELECTOR).attr(ARIA_EXPANDED, 'false');
            }
        } else {
            openMenu = $(MAIN_MENU_SELECTOR + '.in');
            if (openMenu && !$(event.target).closest(NAVBAR_TOGGLER_SELECTOR).length && !$(event.target).closest('#sg-navbar-collapse').length) {
                $(openMenu).find('.close-menu .close-button').trigger('click');
            }
        }
    });
};
